<script>
import { DataService } from '@/services/DataService.js'

export default {
  props: ['method', 'params', 'value'],
  watch: {
    params: {
      immediate: true,
      handler: function (params) {
        this.loading = true
        this.result = null
        this.error = null

        DataService[this.method](params)
          .then((response) => {
            this.result = response.data
          })
          .catch((e) => {
            this.error = e
          }).finally(() => {
            this.loading = false
          })
      }
    }
  },
  data () {
    return {
      loading: true,
      result: null,
      error: null
    }
  },
  render () {
    this.$emit('input', this.result)
    return this.$scopedSlots.default({
      loading: this.loading,
      error: this.error
    })
  }
}
</script>
